App = App || {};

App.ManageDealers = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("manage-dealers");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = true;

		new Vue({
			el: rootElement,
			data: {
				fieldDefs: [
					{ key: "isProstaff", label: "", sortable: false },
					{ key: "bpCode", label: "Bp Code", sortable: true },
					{ key: "cardName", label: "Card Name", sortable: true },
					{ key: "street", label: "Street", sortable: true },
					{ key: "city", label: "City", sortable: true },
					{ key: "region", label: "Region", sortable: true, class: "pl-3" },
					{ key: "country", label: "Country", sortable: true, class: "pl-3" }
				],
				isLoading: false,
				page: 1,
				pageSize: 10,
				searchTerm: "",
				sortBy: "cardName",
				sortDesc: false,
				totalItems: 0,
				firstItem: 0,
				lastItem: 0
			},
			computed: {
				fieldsWithColumnSelect: function () {
					var viewModel = this;
					return viewModel.fieldDefs.map((field) => {
						var sortedClass = viewModel.sortBy === field.key ? "is-sorted" : "";
						return Object.assign({}, field, { thClass: sortedClass, tdClass: sortedClass });
					});
				},
				totalPages: function () {
					return Math.max(1, Math.ceil((this.totalItems || 0) / (this.pageSize || 1)));
				}
			},
			methods: {
				provider: function (context) {
					var requestParameters = {
						page: context.currentPage,
						pageSize: context.perPage,
						searchTerm: this.searchTerm || "",
						sortBy: context.sortBy || this.sortBy || "",
						sortDir: (context.sortDesc === true) ? "desc" : "asc"
					};

					return $.ajax({
						url: "/api/dealers/paged",
						method: "GET",
						dataType: "json",
						data: requestParameters,
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							context.currentPage = response.data.page;
							context.perPage = response.data.pageSize;
							this.totalItems = response.data.total;
							this.firstItem = response.data.firstItem;
							this.lastItem = response.data.lastItem;
							return response.data.items;
						}

						context.totalItems = 0;
						return [];

					}).catch((error) => {
						console.error("Dealers provider error:", error);
						context.totalItems = 0;
						return [];
					});
				},

				refresh: function () {
					this.page = 1;
					this.$refs.table.refresh();
				},

				formatDate: function (value) {
					if (!value)
						return "";

					const normalizedIsoString = String(value).replace(/(\.\d{3})\d+$/, "$1");
					const date = new Date(normalizedIsoString);

					if (isNaN(date))
						return String(value);

					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				pricesByAspect(item, aspect) {
					const prices = Array.isArray(item?.prices) ? item.prices : [];
					return prices.filter(p => p.aspect === aspect);
				},

				onRowClicked: function (item, index, evt) {
					if (!item || !item.id)
						return;

					if (window.App && App.DealerDetail && App.DealerDetail.open) {
						App.DealerDetail.open(item.id);
					}
				},

				onImportClicked: function () {
					App.DealerImport.open(() => this.refresh());
				}
			},
			mounted: function () {
				this.$nextTick(() => {
					this.$refs.table.refresh();
				});
			}
		});
	}

	return { init: init };
})(jQuery, Vue);

App.ManageDealers.init();
